<template>
    <div class="chat-wrapper">
        <div v-if="processing">
            <vue-simple-spinner ></vue-simple-spinner>
        </div>
        <div v-else>
            <div v-if="processed">
                <div v-if="showChat">

                    <ol>
                        <li v-for="message in messages"> <!-- pojedyncza wiadomość, wiadomości wyświetlane od najstarszej do najnowszej (na dole), suwak przewinięty na sam dół - jak na YT) -->
                            <div class="user">
                                <span v-html="message.nick"></span>
                                <span class="chat-meta" v-html="message.time"></span>
                                <button v-if="is_admin" class='live__chat-delete border-0 bg-white' v-on:click="deleteMessage(message.id)">
                                    <i class='bi bi-trash'>
                                    <img v-bind:src="getAssetPath('img/trash.png')" alt="">
                                    </i>
                                </button>
                            </div>

                            <blockquote>
                                <!-- Quick fix przepełniania tekstu -->
                                <p style="overflow-wrap: break-word;" v-text="message.content">
                                </p>
                            </blockquote>
                        </li>
                    </ol>
                    <div id="f-chat">
                        <div class="form-group">
                            <textarea class="form-control" aria-label="Wiadomość" title="Wiadomość" rows="3" placeholder="Treść Twojej wiadomości..." @keyup.enter="sendMessage" v-model="content"></textarea>
                        </div>

                        <button v-on:click="sendMessage" class="btn btn-primary">Wyślij</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Spinner from "vue-simple-spinner";

export default {
    props: ['webinar_uuid', 'user_id', 'is_admin', 'chat_name', 'asset_path'],
    components: {
        Spinner
    },
    data() {
        return {
            content: null,
            processed: false,
            processing: true,
            showChat: false,
            messages: []
        }
    },
    mounted() {
        this.getChatName();
        this.startListening();
    },
    computed: {
    },
    methods: {
        getChatName() {
            axios.post('/api/chat/set-name', {
                name: this.chat_name
            })
            .then(response => {
                this.processed = true;
                this.processing = false;
                this.fetchMessages();
            }).catch(error => {
                this.$notify({
                    'group': 'foo',
                    'type': 'error',
                    'title': error.response.data.errors.name[0]
                });
            });
        },
        startListening() {
            self = this;
            Echo.private('chat.' + this.webinar_uuid).listen('MessageSent', function (e) {
                self.messages.push(e.message);
            });
            Echo.private('chat.' + this.webinar_uuid).listen('MessageDelete', function (e) {
                self.messages.splice(self.messages.findIndex(function(i){
                    return i.id === e.message.id;
                }), 1);
                self.processing = false;
            });
        },
        fetchMessages() {
            axios.get('/api/chat', {
                params: {
                    webinar_uuid: this.webinar_uuid
                }
            }).then(response => {
                this.messages = response.data.data;
                this.showChat = true;
            }).catch(errorResponse => {
                this.$functions.catchApiErrors(errorResponse, this);
            })
        },
        sendMessage() {
            axios.post('/api/chat/send', {
                content: this.content,
                webinar_uuid: this.webinar_uuid
            })
            .then(response => {
                this.content = null;
            }).catch(errorResponse => {
                this.$functions.catchApiErrors(errorResponse, this);
            });
        },
        deleteMessage(messageId) {
            this.processing = true;
            axios.delete('/api/chat/' + messageId)
            .catch(errorResponse => {
                this.processing = false;
                this.$functions.catchApiErrors(errorResponse, this);
            });
        },
        getAssetPath(path) {
            return this.asset_path + '/' + path;
        }
    }
}
</script>
